import React from "react";
import compose from "lodash/flowRight";
import withAnalytics from "shared/AnalyticsNew/withAnalytics/withAnalytics";
import InternalMentorCardWidgetRoutes from "./InternalMentorCardWidgetRoutes";

const InternalMentorCardWidget = (props) => {
    return (
        <InternalMentorCardWidgetRoutes
            universitySlug={props.match.params.universitySlug}
            primaryApp="university-diglett"
            {...props}
        />
    );
};

export default compose(withAnalytics)(InternalMentorCardWidget);
